(app => {

    app.service("allAccountsDataTable",
        [
            "$state", "modalService", "caseModalService", "insuranceAccountApi", "investmentAccountApi",
            function($state, modalService, caseModalService, insuranceAccountApi, investmentAccountApi) {
                this.dataTableOptions = {
                    title: "All Accounts"
                };

                this.buildDataTableOptions = (accounts) => {
                    this.dataTableOptions.headers = this.getAccountHeaders();

                    this.dataTableOptions.rows = this.getAccountRows(accounts);

                    this.dataTableOptions.filters = this.getAccountFilters(accounts);

                    this.dataTableOptions.rowActions = this.getAccountRowActions();

                    return this.dataTableOptions;
                };

                this.getAccountHeaders = () => {
                    return [
                        {
                            title: "Client",
                            type: "string"
                        },
                        {
                            title: "Account Number",
                            type: "string"
                        },
                        {
                            title: "Line Of Business",
                            type: "string"
                        },
                        {
                            title: "Carrier/Custodian",
                            type: "string"
                        },
                        {
                            title: "Product",
                            type: "string"
                        },
                        {
                            title: "Advisor(s)",
                            type: "string"
                        },
                        {
                            title: "Value/Premium",
                            type: "currency"
                        }
                    ];
                };

                this.getAccountRows = (accounts) => {
                    return accounts.map(account => {
                        const row = {
                            cells: this.mapAccountCells(account),
                            rowObject: account,
                            rowActions: []
                        };

                        if (!!account.ArcGuid) {
                            row.rowActions.push({
                                imgUrl: "/Images/Logos/fig-logo-icon.svg",
                                title: "View FIG Data",
                                action: this.openFigAccountInfo
                            });
                        }

                        if (!!account.AcmGuid) {
                            row.rowActions.push({
                                imgUrl: "/Images/Logos/alphastar-logo-icon.svg",
                                title: "View ACM Data",
                                action: this.openAcmAccountInfo
                            });
                        }

                        return row;
                    });
                };

                this.getAccountFilters = (accounts) => {
                    return [
                        {
                            index: 2,
                            label: "Line Of Businesses",
                            options: this.getLineOfBusinessFilters()
                        },
                        {
                            index: 3,
                            label: "Carrier/Custodian",
                            options: this.getCarrierCustodianFilters(accounts)
                        },
                        {
                            index: 4,
                            label: "Products",
                            options: this.getProductFilters(accounts.filter(account => !!account.InsuranceAccountId))
                        },
                        {
                            index: 5,
                            label: "Advisors",
                            options: this.getAdvisorFilters(accounts)
                        }
                    ];
                };

                this.getAccountRowActions = () => {
                    return [
                        {
                            title: "Go to Account",
                            iconName: "mdi-arrow-right",
                            action: this.goToAccount
                        },
                        {
                            title: "Delete Account",
                            iconName: "mdi-delete",
                            className: "btn-warning",
                            action: this.deleteAccount
                        }
                    ];
                };

                this.mapAccountCells = (account) => {
                    const cells = [
                        `${account.Owner ? account.Owner.FirstName : null} ${account.Owner ? account.Owner.LastName : null}`,
                        account.AccountNumber
                    ];

                    if (!!account.InsuranceAccountId) {
                        //const totalIssuedPremium =
                        //    account.FundingSources.reduce((total, source) => total + source.ActualAmount, 0);
                        const totalIssuedPremium = account.IssuedAmount;
                        return [
                            ...cells,
                            account.LineOfBusiness ? account.LineOfBusiness :'',
                            account.CarrierName ? account.CarrierName : '',
                            account.Product ? account.Product :'',
                            this.mapAdvisors(account.Advisors),
                            totalIssuedPremium
                        ];
                    } else if (!!account.InvestmentAccountId) {
                        return [
                            ...cells,
                            "Investment",
                            account.Custodian,
                            "",
                            `${account.Owner.Advisor ? account.Owner.Advisor.FirstName : null} ${account.Owner.Advisor ? account.Owner.Advisor.LastName : null}`,
                            account.AccountValue
                        ];
                    }

                    return cells;
                };

                this.mapAdvisors = (advisors) => {
                    return advisors.sort((a, b) => (a.FirstName > b.FirstName))
                        .map(advisor => `${advisor.FirstName} ${advisor.LastName}`)
                        .join(", ");
                };

                this.flatten = (arr) => {
                    return arr.reduce((a, b) => a.concat(Array.isArray(b) ? this.flatten(b) : b), []);
                };

                this.goToAccount = (account) => {
                    $state.go("Home.Client.Case",
                        { clientId: account.Owner.PersonId, caseId: account.CaseId },
                        {});
                };

                this.deleteAccount = (account) => {
                    caseModalService.confirmAccountDeletion().then(() => {
                        const accountId = account.InsuranceAccountId || account.InvestmentAccountId;

                        const rowIndex = this.dataTableOptions.rows.findIndex(row => {
                            return row.rowObject.InsuranceAccountId === accountId ||
                                row.rowObject.InvestmentAccountId === accountId;
                        });

                        this.dataTableOptions.rows.splice(rowIndex, 1);

                        if (!!account.InsuranceAccountId) {
                            insuranceAccountApi.delete(accountId);
                        } else {
                            investmentAccountApi.delete(accountId);
                        }
                    });
                };


                this.openFigAccountInfo = (account, $event) => {
                    modalService.openFigAccountInfo(account.ArcGuid, $event);
                };

                this.openAcmAccountInfo = (account, $event) => {
                    modalService.openAcmAccountInfo(account.AcmGuid, $event);
                };

                this.removeDuplicateObjects = (arr) => {
                    return arr.filter((obj, index, self) => {
                        return index === self.findIndex(o => o.label === obj.label);
                    });
                };

                this.getLineOfBusinessFilters = () => {
                    let lineOfBusinesses = [
                        "Annuity",
                        "Life",
                        "Long Term Care",
                        "Medicare",
                        "Investment"
                    ].map(lob => {
                        return {
                            selected: false,
                            label: lob
                        };
                    });

                    return this.removeDuplicateObjects(lineOfBusinesses);
                };

                this.getCarrierCustodianFilters = (accounts) => {
                    let carrierCustodians = accounts.map(account => {
                        if (!!account.InsuranceAccountId) {
                            return {
                                selected: false,
                                label: account.CarrierName ? account.CarrierName : ''
                            };
                        }

                        return {
                            selected: false,
                            label: account.Custodian ? account.Custodian : ''
                        };
                    });

                    return this.removeDuplicateObjects(carrierCustodians);
                };

                this.getProductFilters = (accounts) => {
                    let products = accounts.map(account => {
                        return {
                            selected: false,
                            label: account.CarrierName ? account.CarrierName :''
                        };
                    });

                    return this.removeDuplicateObjects(products);
                };

                this.getAdvisorFilters = (accounts) => {
                    let advisors = accounts.map(account => {
                        if (!!account.InsuranceAccountId) {
                            return account.Advisors.map(advisor => {
                                return {
                                    selected: false,
                                    label: `${advisor.FirstName} ${advisor.LastName}`
                                };
                            });
                        }

                        return {
                            selected: false,
                            label: `${account.Owner.Advisor ? account.Owner.Advisor.FirstName : null} ${account.Owner.Advisor ? account.Owner.Advisor.LastName : null}`
                        };
                    });

                    return this.removeDuplicateObjects(this.flatten(advisors));
                };
            }
        ]);

})(window.app);